import { Box, GridProps, Stack } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

interface Props {
  onClick?: () => void;
  size?: GridProps['size'];
  title: string;
  value: boolean | number | string | undefined;
}

export const DetailsViewItem: React.FC<Props> = props => {
  const { onClick, size, title, value } = props;

  return (
    <Grid size={size ?? 3}>
      <Stack>
        <Typography sx={{ color: themeColors.grey }} variant="f14Regular">
          {title}:
          <Box
            onClick={onClick}
            sx={{
              color: themeColors.greyDark,
              cursor: value && onClick ? 'pointer' : 'default',
              textDecoration: value && onClick ? 'underline' : 'none',
              width: 'auto',
            }}
          >
            {typeof value === 'boolean' ? (
              <Checkbox checked={value} disabled sx={{ pt: 1 }} value={value} />
            ) : (
              (value ?? ' - ')
            )}
          </Box>
        </Typography>
      </Stack>
    </Grid>
  );
};
